import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { NavigationItem } from 'app/core/navigation/navigation.types';
import { appAnimations } from 'app/animations';
import { randomId } from 'app/shared/utils/id.util';

@Component({
    selector: 'app-horizontal-nav',
    templateUrl: './horizontal-nav.component.html',
    styleUrls: ['./horizontal-nav.component.scss'],
    animations: appAnimations,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HorizontalNavComponent implements OnChanges, OnInit, OnDestroy {
    @Input() name: string = randomId();
    @Input() navigation: NavigationItem[] = [];

    onRefreshed = new ReplaySubject<boolean>(1);
    private _unsubscribeAll = new Subject<void>();

    constructor(private _cdr: ChangeDetectorRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        if ('navigation' in changes) this._cdr.markForCheck();
    }

    ngOnInit(): void {
        if (this.name === '') this.name = randomId();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    refresh(): void {
        this._cdr.markForCheck();
        this.onRefreshed.next(true);
    }

    trackByFn(index: number, item: NavigationItem): string | number {
        return item.id ?? index;
    }
}
